import { useEffect } from 'react';
import { createWeb3Modal } from '@web3modal/wagmi/react';

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '#/routes-external';

import { cCC38FF } from '#/colors';
import { useWalletConnectConfig } from '#/features/wallet/wallet-connect-context';

const theme = {
  '--w3m-accent': cCC38FF,
};

/**
 * Loads the WalletConnect modal.
 * Rendering this component makes assets load in the background.
 * To reduce page load time, it can be rendered only when needed.
 */
export default function WalletConnectModal() {
  const config = useWalletConnectConfig();

  useEffect(() => {
    const {
      wagmiConfig,
      projectId,
      chains,
      activeChain,
      recommendedWalletIds,
    } = config;
    createWeb3Modal({
      projectId,
      wagmiConfig,
      chains,
      themeMode: 'dark',
      featuredWalletIds: recommendedWalletIds,
      defaultChain: activeChain,
      themeVariables: theme,
      termsConditionsUrl: TERMS_OF_SERVICE_URL,
      privacyPolicyUrl: PRIVACY_POLICY_URL,
    });
  }, [config]);

  return null;
}
